import './shared-styles/index.scss';

import { FoodSearchComponent } from "./components/search-input/search-input.component";
import { InputRoundComponent } from "./components/round-input/round-input.component";
// import { PaletteComponent } from "./components/palette/palette.component";
import { CardNestedComponent } from "./components/card-nested/card-nested.component";
import { TrackedInfoComponent } from "./components/tracked-info/tracked-info.component";
import { ExerciseChartComponent } from "./components/exercise-chart/exercise-chart.component";
import { AvatarComponent } from "./components/avatar/avatar.component";
import { ProgressComponent } from "./components/progress/progress.component";
import { TrackedComponent } from "./components/tracked/tracked.component";
import { WeekProgressComponent } from "./components/week-progress/week-progress.component";
import { TipsModalComponent } from "./components/tips-modal/tips-modal.component";
import { PurchaseTipsModalComponent } from "./components/purchase-tips-modal/purchase-tips-modal.component";
import { ModalsComponent } from "./components/modals/modals.component";
import { ModalsService } from "./components/modals/modals.service";
import { ModalMagnificService } from "./components/modals/magnific/modal-magnific.service";
import {
ModalComponent, ModalAlertComponent, ModalConfirmComponent, ModalPromptComponent, ModalMagnificComponent, ModalCustomComponent } from
"./components/modals/modal/modal.component";
import { MealcardModalComponent } from "./components/mealcard-modal/mealcard-modal.component";
import { TabsComponent } from "./components/tabs/tabs";
import { WeekHeaderComponent } from "./components/week-header/week-header.component";
import { RecipeMealComponent } from "./components/recipe-meal/recipe-meal.component";
import { EditableTrackedComponent } from "./components/editable-tracked/editable-tracked.component";
import { SwiperCarouselComponent } from "./components/swiper-carousel/swiper-carousel.component";
import { SwiperSlideComponent } from "./components/swiper-carousel/swiper-slide/swiper-slide.component";
import { SnowViewStatsComponent } from "./components/snow-view-stats/snow-view-stats.component";
import { ChartComponent } from "./components/chart/chart.component";
import { MealRecipesListComponent } from "./components/meal-recipes-list/meal-recipes-list.component";
import { FiltersComponent } from "./components/filters/filters.component";
import { ResourceListComponent } from "./components/resource-list/resource-list.component";
import { CheckboxComponent } from "./components/checkbox/checkbox.component";
import { SettingFieldComponent } from "./components/setting-field/setting-field.component";
import { SwitcherComponent } from "./components/switcher/switcher.component";
import { ListMilestonesComponent } from "./components/list-milestones/list-milestones.component";
import { RecommendedRecipesListComponent } from "./components/recommended-recipes-list/recommended-recipes-list.component";
import { TipsComponent } from "./components/tips/tips";
import { inputAutoWidthDirective } from "./directives/input-auto-width";
import { textareaAutoHeightDirective } from "./directives/textarea-auto-height";
import { upperFirstLetterFilter } from "./filters/upper-first-letter";
import { uploadChangeDirective } from "./directives/upload-change";
import { PauseModalComponent } from "./components/pause-modal/pause-modal.component";
import { NotificationComponent } from "./components/notification/notification.component";
import { IntroComponent } from "./components/intro/intro.component";
import { UserpicComponent } from "./components/userpic/userpic.component";
import { StaticModalAppComponent } from "./components/static-modal-app/static-modal-app.component";
import { NumberInputComponent } from "./components/number-input/number-input.component";
import { ObdInfoCardComponent } from "./components/obd-info-card/obd-info-card.component";
import { ObdMealCardComponent } from "./components/obd-meal-card/obd-meal-card.component";
import { NeedHelpComponent } from "./components/need-help/need-help.component";
import { InfoSliderComponent } from "./components/info-slider/info-slider.component";
import { FpcComponent } from "./components/fpc/fpc.component";
import { ModuleHeaderComponent } from "./components/moduleHeader/moduleHeader.component";
import { CanvasLoaderComponent } from "./components/canvas-loader/canvas-loader.component";


export var uiModule = angular.
module('gplans.ui', []).

service('ModalsService', ModalsService).
service('ModalMagnificService', ModalMagnificService).

component('uiFoodSearch', FoodSearchComponent).
component('uiInputRound', InputRoundComponent)
// .component('uiPalette', PaletteComponent)
.component('uiCardNested', CardNestedComponent).
component('uiTrackedInfo', TrackedInfoComponent).
component('uiExerciseChart', ExerciseChartComponent).
component('uiAvatar', AvatarComponent).
component('uiProgress', ProgressComponent).
component('uiTracked', TrackedComponent).
component('uiWeekProgress', WeekProgressComponent).
component('uiTipsModal', TipsModalComponent).
component('uiPurchaseTipsModal', PurchaseTipsModalComponent).
component('uiModals', ModalsComponent).
component('uiModal', ModalComponent).
component('uiModalAlert', ModalAlertComponent).
component('uiModalConfirm', ModalConfirmComponent).
component('uiModalPrompt', ModalPromptComponent).
component('uiModalMagnific', ModalMagnificComponent).
component('uiModalCustom', ModalCustomComponent).
component('uiMealcardModal', MealcardModalComponent).
component('uiTabs', TabsComponent).
component('uiWeekHeader', WeekHeaderComponent).
component('uiRecipeMeal', RecipeMealComponent).
component('uiEditableTracked', EditableTrackedComponent).
component('uiSwiperCarousel', SwiperCarouselComponent).
component('uiSwiperSlide', SwiperSlideComponent).
component('uiSnowViewStats', SnowViewStatsComponent).
component('uiChart', ChartComponent).
component('uiMealRecipesList', MealRecipesListComponent).
component('uiFilters', FiltersComponent).
component('uiResourceList', ResourceListComponent).
component('uiCheckbox', CheckboxComponent).
component('uiSettingField', SettingFieldComponent).
component('uiSwitcher', SwitcherComponent).
component('uiListMilestones', ListMilestonesComponent).
component('uiRecommendedRecipesList', RecommendedRecipesListComponent).
component('uiTips', TipsComponent).
component('uiNotification', NotificationComponent).
component('uiIntro', IntroComponent).
component('uiUserpic', UserpicComponent).
component('uiModalAppMobile', StaticModalAppComponent).
component('uiNumberInput', NumberInputComponent).
component('uiObdInfoCard', ObdInfoCardComponent).
component('uiObdMealCard', ObdMealCardComponent).
component('needHelp', NeedHelpComponent).
component('infoSlider', InfoSliderComponent).
component('uiFpc', FpcComponent).
component('moduleHeader', ModuleHeaderComponent).
component('cnvLoader', CanvasLoaderComponent).

directive('pauseModal', PauseModalComponent).
directive('uiInputAutoWidth', inputAutoWidthDirective).
directive('uiTextareaAutoHeight', textareaAutoHeightDirective).
directive('uiUploadChange', uploadChangeDirective).

filter('upperFirstLetter', upperFirstLetterFilter);